// Mock data for Società Quotate (.it) - financial news portal
// NOTE: All data here is MOCK. Will be replaced by backend (OpenAI + RSS) later.

export const NAV_CATEGORIES = [
  { name: "Mercati", slug: "mercati" },
  { name: "Banche", slug: "banche" },
  { name: "Energia", slug: "energia" },
  { name: "Economia", slug: "economia" },
  { name: "Corporate News", slug: "corporate-news" },
  { name: "M&A", slug: "m-a" },
];

export const COMUNICAZIONI_SUB = [
  { name: "Avvisi di Convocazione d'Assemblea", slug: "avvisi-convocazione" },
  { name: "Deposito Relazioni Periodiche", slug: "deposito-relazioni" },
];

const IMG = {
  market1: "https://images.pexels.com/photos/102152/pexels-photo-102152.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  market2: "https://images.pexels.com/photos/534216/pexels-photo-534216.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  corp1: "https://images.pexels.com/photos/13801783/pexels-photo-13801783.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  corp2: "https://images.pexels.com/photos/7108269/pexels-photo-7108269.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  trade1: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3",
  trade2: "https://images.unsplash.com/photo-1553639558-fb2e565066f5",
  trade3: "https://images.pexels.com/photos/35638668/pexels-photo-35638668.jpeg",
  trade4: "https://images.pexels.com/photos/8353831/pexels-photo-8353831.jpeg",
  inv1: "https://images.unsplash.com/photo-1579621970795-87facc2f976d",
  inv2: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab",
  inv3: "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e",
  inv4: "https://images.unsplash.com/photo-1462899006636-339e08d1844e",
  inv5: "https://images.pexels.com/photos/12244851/pexels-photo-12244851.jpeg",
  arch1: "https://images.pexels.com/photos/33463498/pexels-photo-33463498.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  arch2: "https://images.pexels.com/photos/20649748/pexels-photo-20649748.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  arch3: "https://images.pexels.com/photos/13219418/pexels-photo-13219418.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

const para = (s) => s;

export const ARTICLES = [
  {
    id: "1",
    slug: "ftse-mib-chiude-in-rialzo-spinto-dai-bancari",
    title: "FTSE MIB chiude in rialzo, spinto dai titoli bancari",
    excerpt:
      "Piazza Affari archivia la seduta in territorio positivo grazie alla forza del comparto bancario. Gli investitori guardano alle prossime decisioni della BCE.",
    image: IMG.market1,
    category: "Mercati",
    categorySlug: "mercati",
    date: "22 Giugno 2026",
    author: "Redazione Mercati",
    readTime: "4 min",
    featured: true,
    content: [
      "Il FTSE MIB ha chiuso la seduta odierna in rialzo dell'1,2%, sostenuto dalla performance brillante del comparto bancario. Gli operatori hanno premiato i titoli del settore in vista delle prossime indicazioni di politica monetaria attese dalla Banca Centrale Europea.",
      "Tra i migliori della giornata si segnalano i principali istituti di credito, che hanno beneficiato di un contesto di tassi ancora favorevole alla redditività degli impieghi. Il sentiment è stato inoltre supportato da dati macroeconomici migliori delle attese sul fronte della produzione industriale.",
      "Gli analisti sottolineano come la tenuta del mercato dipenda nelle prossime settimane dall'evoluzione dello scenario internazionale e dalle trimestrali in arrivo. La volatilità resta contenuta, segnale di una fase di consolidamento dopo i recenti massimi.",
      "Sul fronte valutario l'euro si è mantenuto stabile, mentre lo spread tra BTP e Bund ha registrato un lieve restringimento, riflettendo un clima di fiducia verso il debito sovrano italiano.",
    ],
  },
  {
    id: "2",
    slug: "bce-tassi-fermi-attesa-per-il-prossimo-meeting",
    title: "BCE, tassi fermi: cresce l'attesa per il prossimo meeting",
    excerpt:
      "La Banca Centrale Europea mantiene invariato il costo del denaro. Il mercato sconta una possibile svolta nel quarto trimestre.",
    image: IMG.inv4,
    category: "Economia",
    categorySlug: "economia",
    date: "21 Giugno 2026",
    author: "Redazione Economia",
    readTime: "5 min",
    featured: true,
    content: [
      "La Banca Centrale Europea ha deciso di mantenere invariati i tassi di interesse, confermando un approccio prudente in una fase ancora caratterizzata da incertezza sui prezzi.",
      "Nel comunicato l'istituto di Francoforte ha ribadito che le future decisioni resteranno dipendenti dai dati, lasciando aperta la porta a possibili interventi nel corso dell'anno.",
      "Gli economisti interpretano il tono come moderatamente accomodante e ritengono probabile una revisione della politica monetaria nel quarto trimestre, qualora l'inflazione confermi il trend di rientro verso l'obiettivo del 2%.",
    ],
  },
  {
    id: "3",
    slug: "intesa-sanpaolo-utili-in-crescita-nel-semestre",
    title: "Intesa Sanpaolo, utili in crescita nel semestre",
    excerpt:
      "Il principale gruppo bancario italiano archivia un semestre solido con ricavi in aumento e una guidance rivista al rialzo.",
    image: IMG.arch1,
    category: "Banche",
    categorySlug: "banche",
    date: "20 Giugno 2026",
    author: "Redazione Banche",
    readTime: "4 min",
    featured: false,
    content: [
      "Il gruppo ha registrato un utile netto in crescita rispetto allo stesso periodo dell'anno precedente, trainato dal margine di interesse e dalle commissioni nette.",
      "Il management ha confermato la solidità patrimoniale e annunciato una guidance rivista al rialzo per l'intero esercizio, rassicurando il mercato sulla generazione di capitale.",
      "La politica di remunerazione degli azionisti resta uno dei punti di forza, con un payout ratio tra i più elevati del settore europeo.",
    ],
  },
  {
    id: "4",
    slug: "eni-piano-energetico-focus-sulle-rinnovabili",
    title: "Eni accelera sul piano energetico: focus rinnovabili",
    excerpt:
      "Il colosso energetico presenta gli aggiornamenti del piano industriale con maggiori investimenti nella transizione.",
    image: IMG.arch2,
    category: "Energia",
    categorySlug: "energia",
    date: "19 Giugno 2026",
    author: "Redazione Energia",
    readTime: "6 min",
    featured: false,
    content: [
      "La società ha illustrato l'aggiornamento del proprio piano industriale, ponendo l'accento sulla crescita della capacità installata da fonti rinnovabili e sui progetti legati alla decarbonizzazione.",
      "Gli investimenti previsti puntano a bilanciare la generazione di cassa del business tradizionale con lo sviluppo delle nuove energie, in un'ottica di sostenibilità di lungo periodo.",
      "Il mercato ha accolto positivamente la disciplina finanziaria comunicata dal management, con particolare attenzione alla politica dei dividendi.",
    ],
  },
  {
    id: "5",
    slug: "ma-operazione-da-due-miliardi-nel-settore-industriale",
    title: "M&A: operazione da due miliardi nel settore industriale",
    excerpt:
      "Annunciata un'aggregazione strategica tra due gruppi quotati. Gli analisti vedono sinergie significative.",
    image: IMG.corp1,
    category: "M&A",
    categorySlug: "m-a",
    date: "18 Giugno 2026",
    author: "Redazione M&A",
    readTime: "5 min",
    featured: true,
    content: [
      "È stata annunciata un'operazione di fusione tra due gruppi industriali quotati, per un controvalore complessivo di circa due miliardi di euro.",
      "L'aggregazione punta a creare un player di dimensioni europee, con sinergie attese sia sul fronte dei costi che su quello commerciale.",
      "Gli analisti valutano positivamente la razionale strategica dell'operazione, sottolineando il potenziale di crescita derivante dall'integrazione delle due realtà.",
    ],
  },
  {
    id: "6",
    slug: "leonardo-nuovo-contratto-internazionale",
    title: "Leonardo si aggiudica un nuovo contratto internazionale",
    excerpt:
      "Il gruppo della difesa rafforza il portafoglio ordini con una commessa di rilievo sui mercati esteri.",
    image: IMG.corp2,
    category: "Corporate News",
    categorySlug: "corporate-news",
    date: "17 Giugno 2026",
    author: "Redazione Corporate",
    readTime: "3 min",
    featured: false,
    content: [
      "Il gruppo ha annunciato l'aggiudicazione di un importante contratto internazionale, che contribuisce a rafforzare ulteriormente il portafoglio ordini.",
      "La commessa, di rilievo strategico, conferma il posizionamento competitivo della società nei mercati esteri ad alta tecnologia.",
      "Il titolo ha reagito positivamente in Borsa, con i volumi di scambio in aumento rispetto alla media degli ultimi giorni.",
    ],
  },
  {
    id: "7",
    slug: "wall-street-mista-tecnologici-sotto-pressione",
    title: "Wall Street mista, tecnologici sotto pressione",
    excerpt:
      "Sedute contrastate oltreoceano. I titoli growth cedono terreno mentre i difensivi tengono.",
    image: IMG.trade1,
    category: "Mercati",
    categorySlug: "mercati",
    date: "17 Giugno 2026",
    author: "Redazione Mercati",
    readTime: "4 min",
    featured: false,
    content: [
      "Le principali piazze statunitensi hanno chiuso in ordine sparso, con i titoli tecnologici sotto pressione a causa di prese di profitto dopo i recenti rialzi.",
      "I settori difensivi hanno mostrato maggiore tenuta, riflettendo un atteggiamento più cauto da parte degli investitori in attesa dei prossimi dati macroeconomici.",
      "Il mercato resta concentrato sulle aspettative di politica monetaria e sull'andamento dei rendimenti dei titoli di Stato.",
    ],
  },
  {
    id: "8",
    slug: "unicredit-buyback-e-dividendi-confermati",
    title: "UniCredit conferma buyback e dividendi",
    excerpt:
      "L'istituto ribadisce l'impegno verso la remunerazione degli azionisti dopo conti solidi.",
    image: IMG.arch3,
    category: "Banche",
    categorySlug: "banche",
    date: "16 Giugno 2026",
    author: "Redazione Banche",
    readTime: "4 min",
    featured: false,
    content: [
      "La banca ha confermato il programma di riacquisto di azioni proprie e la politica di distribuzione dei dividendi, dopo aver pubblicato risultati superiori alle attese.",
      "La solidità patrimoniale e la qualità degli attivi rappresentano i pilastri della strategia di remunerazione degli azionisti.",
      "Gli analisti restano costruttivi sul titolo, evidenziando un profilo di rischio-rendimento ancora attraente.",
    ],
  },
  {
    id: "9",
    slug: "inflazione-italia-in-rallentamento",
    title: "Inflazione in Italia, prosegue il rallentamento",
    excerpt:
      "I dati confermano la discesa dei prezzi al consumo. Migliora il potere d'acquisto delle famiglie.",
    image: IMG.inv1,
    category: "Economia",
    categorySlug: "economia",
    date: "15 Giugno 2026",
    author: "Redazione Economia",
    readTime: "3 min",
    featured: false,
    content: [
      "L'inflazione in Italia ha proseguito il proprio percorso di rallentamento, secondo gli ultimi dati diffusi dall'istituto di statistica.",
      "Il rientro dei prezzi, in particolare sul fronte energetico, contribuisce a sostenere il potere d'acquisto delle famiglie.",
      "Gli economisti ritengono che il trend possa proseguire nei prossimi mesi, pur restando soggetto alle dinamiche dei mercati internazionali.",
    ],
  },
  {
    id: "10",
    slug: "enel-investimenti-rete-e-digitalizzazione",
    title: "Enel punta su rete e digitalizzazione",
    excerpt:
      "Il gruppo annuncia un nuovo ciclo di investimenti nelle infrastrutture elettriche e nei servizi digitali.",
    image: IMG.inv2,
    category: "Energia",
    categorySlug: "energia",
    date: "14 Giugno 2026",
    author: "Redazione Energia",
    readTime: "5 min",
    featured: false,
    content: [
      "La società ha annunciato un nuovo ciclo di investimenti destinato al potenziamento della rete elettrica e alla digitalizzazione dei servizi.",
      "L'obiettivo è migliorare l'affidabilità del sistema e accompagnare la crescente elettrificazione dei consumi.",
      "Il piano è stato accolto con interesse dal mercato, attento alla sostenibilità finanziaria degli investimenti.",
    ],
  },
  {
    id: "11",
    slug: "ipo-in-arrivo-su-euronext-growth-milan",
    title: "Nuova IPO in arrivo su Euronext Growth Milan",
    excerpt:
      "Una PMI innovativa si prepara allo sbarco in Borsa. Forte interesse da parte degli investitori istituzionali.",
    image: IMG.trade2,
    category: "Corporate News",
    categorySlug: "corporate-news",
    date: "13 Giugno 2026",
    author: "Redazione Corporate",
    readTime: "4 min",
    featured: false,
    content: [
      "Una PMI innovativa ha avviato l'iter per la quotazione su Euronext Growth Milan, il mercato dedicato alle piccole e medie imprese ad alto potenziale.",
      "L'operazione ha già raccolto un forte interesse da parte degli investitori istituzionali, attratti dal profilo di crescita della società.",
      "La quotazione rappresenta un'opportunità per finanziare i piani di sviluppo e accrescere la visibilità sul mercato dei capitali.",
    ],
  },
  {
    id: "12",
    slug: "ma-fusione-nel-comparto-tlc",
    title: "M&A: ipotesi di fusione nel comparto TLC",
    excerpt:
      "Indiscrezioni di mercato su una possibile aggregazione tra operatori delle telecomunicazioni.",
    image: IMG.trade3,
    category: "M&A",
    categorySlug: "m-a",
    date: "12 Giugno 2026",
    author: "Redazione M&A",
    readTime: "3 min",
    featured: false,
    content: [
      "Sul mercato circolano indiscrezioni relative a una possibile operazione di aggregazione tra operatori del settore delle telecomunicazioni.",
      "Un eventuale consolidamento potrebbe contribuire a razionalizzare il comparto e a migliorare la redditività degli operatori coinvolti.",
      "Al momento non vi sono conferme ufficiali, ma il tema è seguito con attenzione dagli analisti del settore.",
    ],
  },
  {
    id: "13",
    slug: "petrolio-prezzi-in-altalena-sui-timori-geopolitici",
    title: "Petrolio in altalena sui timori geopolitici",
    excerpt:
      "Le quotazioni del greggio oscillano in scia alle tensioni internazionali e ai dati sulle scorte.",
    image: IMG.inv3,
    category: "Energia",
    categorySlug: "energia",
    date: "11 Giugno 2026",
    author: "Redazione Energia",
    readTime: "3 min",
    featured: false,
    content: [
      "Le quotazioni del petrolio hanno mostrato un andamento volatile, condizionate dalle tensioni geopolitiche e dai dati sulle scorte.",
      "Gli operatori monitorano l'evoluzione dello scenario internazionale, che resta il principale fattore di incertezza per i prezzi.",
      "L'andamento del greggio si riflette sui titoli del comparto energetico quotati a Piazza Affari.",
    ],
  },
  {
    id: "14",
    slug: "borse-europee-positive-in-avvio-di-settimana",
    title: "Borse europee positive in avvio di settimana",
    excerpt:
      "Apertura in rialzo per i principali listini del Vecchio Continente. Sentiment costruttivo sui mercati.",
    image: IMG.market2,
    category: "Mercati",
    categorySlug: "mercati",
    date: "10 Giugno 2026",
    author: "Redazione Mercati",
    readTime: "3 min",
    featured: false,
    content: [
      "I principali listini europei hanno aperto la settimana in territorio positivo, sostenuti da un clima di fiducia sui mercati internazionali.",
      "Gli investitori guardano con interesse alle prossime trimestrali e ai dati macroeconomici in calendario.",
      "Il sentiment resta costruttivo, pur in un contesto che invita alla prudenza dato il livello dei prezzi.",
    ],
  },
];

export const SIDEBAR_HIGHLIGHTS = [
  ARTICLES[0],
  ARTICLES[4],
  ARTICLES[7],
  ARTICLES[9],
];

export const COMUNICAZIONI = {
  "avvisi-convocazione": [
    {
      id: "c1",
      slug: "avviso-convocazione-assemblea-gas-plus-16-giugno-2026",
      title: "Avviso di convocazione Assemblea Gas Plus S.p.A. del 16 giugno 2026",
      company: "Gas Plus S.p.A.",
      date: "16 Giugno 2026",
      summary:
        "Convocazione dell'Assemblea ordinaria e straordinaria degli azionisti per l'approvazione del bilancio e le deliberazioni connesse.",
    },
    {
      id: "c2",
      slug: "avviso-convocazione-assemblea-fincantieri-14-maggio-2026",
      title: "Avviso di Convocazione Assemblea Fincantieri del 14 maggio 2026",
      company: "Fincantieri S.p.A.",
      date: "14 Maggio 2026",
      summary:
        "Avviso di convocazione dell'Assemblea degli azionisti con l'ordine del giorno e le modalità di partecipazione.",
    },
    {
      id: "c3",
      slug: "avviso-convocazione-assemblea-marr-28-04-2026",
      title: "Avviso Convocazione Assemblea Marr del 28 aprile 2026",
      company: "Marr S.p.A.",
      date: "28 Aprile 2026",
      summary:
        "Convocazione dell'Assemblea ordinaria per l'approvazione del bilancio di esercizio e le deliberazioni inerenti.",
    },
    {
      id: "c4",
      slug: "avviso-convocazione-assemblea-valsoia-23-aprile-2026",
      title: "Avviso di Convocazione assemblea Valsoia del 23 aprile 2026",
      company: "Valsoia S.p.A.",
      date: "23 Aprile 2026",
      summary:
        "Avviso ufficiale di convocazione dell'Assemblea degli azionisti con indicazione delle modalità di intervento.",
    },
  ],
  "deposito-relazioni": [
    {
      id: "d1",
      slug: "avviso-deposito-documentazione-assemblea-fincantieri-14-maggio-2026",
      title: "Avviso deposito Documentazione Assemblea Fincantieri 14 maggio 2026",
      company: "Fincantieri S.p.A.",
      date: "30 Aprile 2026",
      summary:
        "Deposito presso la sede sociale della documentazione relativa ai punti all'ordine del giorno dell'Assemblea.",
    },
    {
      id: "d2",
      slug: "deposito-relazione-semestrale-2026-eni",
      title: "Deposito Relazione Finanziaria Semestrale 2026 - Eni",
      company: "Eni S.p.A.",
      date: "25 Aprile 2026",
      summary:
        "Messa a disposizione del pubblico della relazione finanziaria semestrale approvata dal Consiglio di Amministrazione.",
    },
    {
      id: "d3",
      slug: "deposito-bilancio-annuale-2025-enel",
      title: "Deposito Bilancio Annuale 2025 - Enel",
      company: "Enel S.p.A.",
      date: "10 Aprile 2026",
      summary:
        "Pubblicazione della relazione finanziaria annuale e dei documenti allegati ai sensi della normativa vigente.",
    },
    {
      id: "d4",
      slug: "deposito-resoconto-intermedio-q1-2026-intesa",
      title: "Deposito Resoconto Intermedio di Gestione Q1 2026 - Intesa Sanpaolo",
      company: "Intesa Sanpaolo S.p.A.",
      date: "5 Aprile 2026",
      summary:
        "Deposito del resoconto intermedio di gestione relativo al primo trimestre dell'esercizio.",
    },
  ],
};

export const SOCIETA = [
  { id: "s1", name: "Intesa Sanpaolo", ticker: "ISP", sector: "Banche", price: "3,84", change: "+1,12", up: true, mercato: "FTSE MIB" },
  { id: "s2", name: "UniCredit", ticker: "UCG", sector: "Banche", price: "38,21", change: "+0,87", up: true, mercato: "FTSE MIB" },
  { id: "s3", name: "Eni", ticker: "ENI", sector: "Energia", price: "14,56", change: "-0,42", up: false, mercato: "FTSE MIB" },
  { id: "s4", name: "Enel", ticker: "ENEL", sector: "Energia", price: "6,78", change: "+0,33", up: true, mercato: "FTSE MIB" },
  { id: "s5", name: "Leonardo", ticker: "LDO", sector: "Difesa", price: "22,90", change: "+2,05", up: true, mercato: "FTSE MIB" },
  { id: "s6", name: "Fincantieri", ticker: "FCT", sector: "Industriale", price: "0,89", change: "-0,55", up: false, mercato: "FTSE MIB" },
  { id: "s7", name: "Generali", ticker: "G", sector: "Assicurazioni", price: "26,14", change: "+0,48", up: true, mercato: "FTSE MIB" },
  { id: "s8", name: "Stellantis", ticker: "STLA", sector: "Automotive", price: "12,33", change: "-1,20", up: false, mercato: "FTSE MIB" },
  { id: "s9", name: "Ferrari", ticker: "RACE", sector: "Automotive", price: "412,60", change: "+0,95", up: true, mercato: "FTSE MIB" },
  { id: "s10", name: "Moncler", ticker: "MONC", sector: "Lusso", price: "58,40", change: "+1,34", up: true, mercato: "FTSE MIB" },
  { id: "s11", name: "Telecom Italia", ticker: "TIT", sector: "TLC", price: "0,24", change: "-0,80", up: false, mercato: "FTSE MIB" },
  { id: "s12", name: "Gas Plus", ticker: "GSP", sector: "Energia", price: "2,46", change: "+0,40", up: true, mercato: "Euronext STAR" },
  { id: "s13", name: "Marr", ticker: "MARR", sector: "Food", price: "11,28", change: "+0,21", up: true, mercato: "Euronext STAR" },
  { id: "s14", name: "Valsoia", ticker: "VLS", sector: "Food", price: "9,15", change: "-0,30", up: false, mercato: "Euronext STAR" },
  { id: "s15", name: "Datrix", ticker: "DTX", sector: "Tech", price: "2,80", change: "+3,10", up: true, mercato: "Euronext Growth" },
  { id: "s16", name: "Svas Biosana", ticker: "SVS", sector: "Healthcare", price: "5,62", change: "+1,75", up: true, mercato: "Euronext Growth" },
];

export const MARKET_INDICES = [
  { name: "FTSE MIB", value: "34.812", change: "+0,82%", up: true },
  { name: "FTSE Italia STAR", value: "48.205", change: "+0,41%", up: true },
  { name: "EURO STOXX 50", value: "5.014", change: "-0,12%", up: false },
  { name: "DAX", value: "18.622", change: "+0,55%", up: true },
  { name: "Spread BTP-Bund", value: "132", change: "-3 pb", up: true },
  { name: "EUR/USD", value: "1,0842", change: "+0,15%", up: true },
];

export const getArticleBySlug = (slug) => ARTICLES.find((a) => a.slug === slug);
export const getArticlesByCategory = (slug) =>
  ARTICLES.filter((a) => a.categorySlug === slug);
export const getRelated = (article) =>
  ARTICLES.filter(
    (a) => a.categorySlug === article.categorySlug && a.id !== article.id
  ).slice(0, 3);

export const TODAY_LABEL = "Lun. Giu 22nd, 2026";
